import {isNotNil} from 'ramda';

import {PromoPhotosFormType} from '../types/PromoPhotosFormType';
import {PromoPhotosType} from '../types/PromoPhotosType';
import {VehicleSelectionMode} from '../types/VehicleSelectionMode';

const DEFAULT_SOURCE_PHOTO_INDEX = 1;

export const getPromoPhotoDefaultValues = (editData?: PromoPhotosType): PromoPhotosFormType => ({
  title: editData?.title ?? '',
  position: editData?.position ?? DEFAULT_SOURCE_PHOTO_INDEX,
  type: editData?.type ?? 'REGULAR',
  fileId:
    isNotNil(editData?.fileId) && isNotNil(editData?.url)
      ? {id: editData.fileId, url: editData.url}
      : null,
  financialProductType: editData?.financialProductType ?? null,
  sourcePhotoIndex: editData?.sourcePhotoIndex ?? DEFAULT_SOURCE_PHOTO_INDEX,
  composition: editData?.composition ?? null,
  autoAssign: editData?.autoAssign ?? false,
  vehicleSelectionMode: isNotNil(editData?.vehicleSelection)
    ? VehicleSelectionMode.BY_CONDITIONS
    : VehicleSelectionMode.ALL_VEHICLES,
  filter: editData?.vehicleSelection ?? {},
});
